(function () {
  'use strict';

  /* 1) Form con data-smart-cart-form (pagina carrello): checkout bloccato sotto il minimo. */
  function blockInvalidCheckout(event) {
    var form = event.target && event.target.closest ? event.target.closest('[data-smart-cart-form]') : null;
    if (!form) return;

    var blockedButton = form.querySelector('[data-smart-checkout-blocked]');
    if (!blockedButton) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    blockedButton.focus({ preventScroll: false });
  }

  /* 2) Carrello a scomparsa (form#mini-cart): sotto il minimo d'ordine il pulsante e' un
        invito (data-smart-checkout-nudge, type="button"). Finche' e' presente, nessun invio
        del form arriva al checkout (es. tasto Invio in un campo quantita'). */
  function blockDrawerCheckout(event) {
    var form = event.target;
    if (!form || form.id !== 'mini-cart' || !form.querySelector) return;
    if (!form.querySelector('[data-smart-checkout-nudge]')) return;

    event.preventDefault();
    event.stopImmediatePropagation();
  }

  document.addEventListener('submit', blockInvalidCheckout, true);
  document.addEventListener('submit', blockDrawerCheckout, true);
  document.addEventListener('click', function (event) {
    var checkout = event.target && event.target.closest ? event.target.closest('[data-smart-checkout-blocked]') : null;
    if (!checkout) return;
    event.preventDefault();
    event.stopImmediatePropagation();
  }, true);

  /* 3) Click sul pulsante-invito: scorre l'area del carrello fino ai consigli
        ([data-smart-cart-nudge-target]) e li evidenzia per 1,2 s.
        Se non ci sono consigli, torna in cima al box spedizione. */
  function reducedMotion() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  function scrollParent(element, stopAt) {
    var node = element.parentElement;
    while (node && node !== stopAt && node !== document.body) {
      var style = window.getComputedStyle(node);
      if (/(auto|scroll)/.test(style.overflowY) && node.scrollHeight > node.clientHeight + 1) return node;
      node = node.parentElement;
    }
    return null;
  }

  function highlight(target) {
    target.classList.remove('sa-nudge-pulse');
    void target.offsetWidth;
    target.classList.add('sa-nudge-pulse');
    window.clearTimeout(target.saNudgeTimer);
    target.saNudgeTimer = window.setTimeout(function () {
      target.classList.remove('sa-nudge-pulse');
    }, 1300);
  }

  document.addEventListener('click', function (event) {
    var nudge = event.target && event.target.closest ? event.target.closest('[data-smart-checkout-nudge]') : null;
    if (!nudge) return;
    event.preventDefault();

    var root = nudge.closest('#mini-cart') || document;
    var target = root.querySelector('[data-smart-cart-nudge-target]');
    var toTop = !target;
    if (toTop) target = root.querySelector('[data-smart-cart-progress]') || root.querySelector('.sa-cart-top');
    if (!target) return;

    var behavior = reducedMotion() ? 'auto' : 'smooth';
    var scroller = scrollParent(target, root === document ? null : root.parentNode);

    if (scroller) {
      var top = 0;
      if (!toTop) {
        var sticky = scroller.querySelector('.sa-cart-top');
        var stickyHeight = sticky ? sticky.offsetHeight : 0;
        top = target.getBoundingClientRect().top - scroller.getBoundingClientRect().top + scroller.scrollTop - stickyHeight - 8;
      }
      top = Math.max(0, top);
      try {
        scroller.scrollTo({ top: top, behavior: behavior });
      } catch (error) {
        scroller.scrollTop = top;
      }
    } else if (target.scrollIntoView) {
      try {
        target.scrollIntoView({ behavior: behavior, block: 'nearest' });
      } catch (error) {
        target.scrollIntoView(false);
      }
    }

    highlight(target);
  });

  /* 4) Scroll touch nel carrello a scomparsa (mobile) - round 9, un solo meccanismo.
        Un listener touchmove su window in fase di CAPTURE: per i tocchi dentro l'area che
        scorre (#mini-cart .mini-cart__content) ferma la propagazione, cosi' nessun altro
        handler touchmove della pagina li vede (blocco scroll del tema sul document, eventuali
        resti del vecchio carosello upsell). Non chiama mai preventDefault: lo scroll nativo resta.
        Se il contenuto non e' piu' alto dell'area (niente da scorrere) non interviene, cosi' il
        blocco del tema impedisce alla pagina dietro il cassetto di scorrere.
        Sta su window: sopravvive ai re-render del carrello senza ricollegamenti.
        touchstart (stesso modo, senza fermare la propagazione: i pulsanti ne hanno bisogno):
        tiene lo scroll a 1 px dai bordi, per i vecchi iOS che ignorano overscroll-behavior. */
  var SCROLL_AREA_SELECTOR = '#mini-cart .mini-cart__content';

  function scrollAreaFor(target) {
    return target && target.closest ? target.closest(SCROLL_AREA_SELECTOR) : null;
  }

  function maxScroll(area) {
    return area.scrollHeight - area.clientHeight;
  }

  window.addEventListener('touchmove', function (event) {
    var area = scrollAreaFor(event.target);
    if (!area || maxScroll(area) <= 1) return;
    event.stopPropagation();
  }, { capture: true, passive: true });

  window.addEventListener('touchstart', function (event) {
    var area = scrollAreaFor(event.target);
    if (!area) return;
    var max = maxScroll(area);
    if (max <= 1) return;
    if (area.scrollTop <= 0) area.scrollTop = 1;
    else if (area.scrollTop >= max) area.scrollTop = max - 1;
  }, { capture: true, passive: true });

  /* 5) Prodotti kit (metafield custom.kit_komponenten, es. Welcome Kit) - 12/10/2026.
        Rete di sicurezza: magazzino e logistica non devono MAI ricevere una riga kit.
        La scheda prodotto aggiunge gia' le varianti componenti; se una riga kit arriva
        comunque nel carrello (app, link diretto, pagina in cache) qui viene sostituita:
          1. POST cart/add.js {items: [{id: componente, quantity: q}, ...]}
          2. SOLO se l'aggiunta riesce: POST cart/change.js {id: chiave riga, quantity: 0}
          3. carrello a scomparsa: evento cart:refresh (ridisegno); pagina carrello: ricarica.
        Se l'aggiunta fallisce (es. componente esaurito) la riga kit resta, il checkout resta
        bloccato e sopra il pulsante checkout compare un breve messaggio (KIT_ERROR_TEXT).
        Se l'aggiunta riesce ma la rimozione no, i tentativi successivi rifanno solo la rimozione
        (nessun componente aggiunto due volte).
        Le righe kit sono marcate in Liquid (snippets/mini-cart.liquid, sections/main-cart.liquid):
        data-sa-kit-line="chiave riga", data-sa-kit-qty, data-sa-kit-components="id1,id2".
        Controllo: al caricamento, dopo product:added / cart:refresh / cart:rerendered e con un
        MutationObserver (ogni ridisegno del carrello). Anti-loop: uno scambio alla volta
        (kitBusy), chiavi appena scambiate ignorate per 5 s (DOM non ancora ridisegnato),
        al massimo 2 tentativi automatici per chiave riga nella sessione (il checkout riprova sempre).
        Checkout: finche' esiste una riga kit l'invio del form checkout viene fermato,
        si fa lo scambio e solo se riesce si invia di nuovo il form verso il checkout. */
  var KIT_SELECTOR = '[data-sa-kit-line]';
  var KIT_STORE_KEY = 'saKitSwapState';
  var KIT_MAX_AUTO = 2;
  var KIT_ERROR_TEXT = 'Dieses Set ist gerade nicht verfügbar. Bitte entferne es aus dem Warenkorb.';
  var kitBusy = null;
  var kitCheckoutPending = false;
  var kitRecent = {};
  var kitMemory = {};
  var kitTimer = null;

  /* Stato per chiave riga: { tries: tentativi, added: componenti gia' aggiunti, failed: aggiunta fallita } */
  function kitStateAll() {
    try {
      var stored = JSON.parse(window.sessionStorage.getItem(KIT_STORE_KEY) || '{}');
      if (stored && typeof stored === 'object') return stored;
    } catch (error) {}
    return kitMemory;
  }

  function kitState(key) {
    var stored = kitStateAll()[key] || {};
    var memory = kitMemory[key] || {};
    return {
      tries: Math.max(stored.tries || 0, memory.tries || 0),
      added: !!(stored.added || memory.added),
      failed: !!(stored.failed || memory.failed)
    };
  }

  function setKitState(key, changes) {
    var state = kitState(key);
    for (var name in changes) {
      if (Object.prototype.hasOwnProperty.call(changes, name)) state[name] = changes[name];
    }
    kitMemory[key] = state;
    var all = kitStateAll();
    all[key] = state;
    try { window.sessionStorage.setItem(KIT_STORE_KEY, JSON.stringify(all)); } catch (error) {}
  }

  function kitLines() {
    var seen = {};
    var lines = [];
    Array.prototype.forEach.call(document.querySelectorAll(KIT_SELECTOR), function (node) {
      var key = node.getAttribute('data-sa-kit-line');
      if (!key || seen[key]) return;
      seen[key] = true;
      var ids = (node.getAttribute('data-sa-kit-components') || '').split(',').map(function (id) {
        return parseInt(id, 10);
      }).filter(function (id) {
        return id > 0;
      });
      lines.push({ key: key, qty: parseInt(node.getAttribute('data-sa-kit-qty'), 10) || 0, ids: ids });
    });
    return lines;
  }

  function kitRoot() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root.charAt(root.length - 1) === '/' ? root : root + '/';
  }

  function kitPost(path, body) {
    return fetch(kitRoot() + path, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    }).then(function (response) {
      if (!response.ok) {
        var error = new Error(path + ' HTTP ' + response.status);
        error.kitStep = path;
        throw error;
      }
      return response.json();
    });
  }

  function isCartPage() {
    return !!document.querySelector('[data-section-type="cart"]');
  }

  /* Messaggio sopra ogni pulsante checkout (carrello a scomparsa e pagina carrello) */
  function kitCheckoutButtons() {
    return Array.prototype.slice.call(document.querySelectorAll('#mini-cart [name="checkout"], [data-smart-cart-form] [name="checkout"]'));
  }

  function showKitError() {
    kitCheckoutButtons().forEach(function (button) {
      var previous = button.previousElementSibling;
      if (previous && previous.hasAttribute('data-sa-kit-error')) return;
      var message = document.createElement('p');
      message.setAttribute('data-sa-kit-error', '');
      message.setAttribute('role', 'alert');
      message.className = 'sa-kit-error';
      message.style.cssText = 'margin:0 0 8px;font-size:13px;line-height:1.4;font-weight:600;color:#b3261e;text-align:left;';
      message.textContent = KIT_ERROR_TEXT;
      button.parentNode.insertBefore(message, button);
    });
  }

  function hideKitError() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-sa-kit-error]'), function (node) {
      node.parentNode.removeChild(node);
    });
  }

  function syncKitError() {
    var failed = kitLines().some(function (line) {
      return kitState(line.key).failed;
    });
    if (failed) showKitError();
    else hideKitError();
  }

  /* Risultato: null = nessuna riga da scambiare, true = scambio riuscito, false = errore. */
  function swapKitLines(force) {
    if (kitBusy) return kitBusy;
    var now = Date.now();
    var lines = kitLines().filter(function (line) {
      /* Riga gia' scambiata con successo da meno di 5 s: e' solo il DOM non ancora ridisegnato. */
      if (kitRecent[line.key] && now - kitRecent[line.key] < 5000) return false;
      return force || kitState(line.key).tries < KIT_MAX_AUTO;
    });
    if (!lines.length) return Promise.resolve(null);

    var allOk = true;
    kitBusy = lines.reduce(function (chain, line) {
      return chain.then(function () {
        var state = kitState(line.key);
        setKitState(line.key, { tries: state.tries + 1 });
        if (!line.qty || !line.ids.length) {
          setKitState(line.key, { failed: true });
          allOk = false;
          return null;
        }
        var addStep = state.added ? Promise.resolve() : kitPost('cart/add.js', {
          items: line.ids.map(function (id) {
            return { id: id, quantity: line.qty };
          })
        }).then(function () {
          setKitState(line.key, { added: true, failed: false });
        });
        return addStep.then(function () {
          return kitPost('cart/change.js', { id: line.key, quantity: 0 });
        }).then(function () {
          setKitState(line.key, { added: false, failed: false });
          kitRecent[line.key] = Date.now();
        }, function (error) {
          allOk = false;
          if (error && error.kitStep === 'cart/add.js') setKitState(line.key, { failed: true });
          if (window.console && window.console.warn) window.console.warn('[SicilyAddict kit]', error);
        });
      });
    }, Promise.resolve()).then(function () {
      return allOk;
    }, function (error) {
      if (window.console && window.console.warn) window.console.warn('[SicilyAddict kit]', error);
      return false;
    }).then(function (result) {
      kitBusy = null;
      syncKitError();
      return result;
    });
    return kitBusy;
  }

  function refreshAfterKit() {
    if (kitCheckoutPending) return;
    if (isCartPage()) {
      window.location.reload();
    } else {
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    }
  }

  function scheduleKitScan() {
    window.clearTimeout(kitTimer);
    kitTimer = window.setTimeout(function () {
      if (kitBusy || kitCheckoutPending) return;
      if (!document.querySelector(KIT_SELECTOR)) {
        if (document.querySelector('[data-sa-kit-error]')) hideKitError();
        return;
      }
      syncKitError();
      swapKitLines(false).then(function (result) {
        /* Aggiunta fallita: niente ridisegno (eviterebbe solo di rimostrare il messaggio). */
        if (result === true) refreshAfterKit();
        else if (result === false && !document.querySelector('[data-sa-kit-error]')) refreshAfterKit();
      });
    }, 80);
  }

  ['product:added', 'cart:refresh', 'cart:rerendered'].forEach(function (name) {
    document.documentElement.addEventListener(name, scheduleKitScan);
    document.addEventListener(name, scheduleKitScan);
  });

  if (window.MutationObserver) {
    var kitObserver = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].addedNodes && mutations[i].addedNodes.length) {
          scheduleKitScan();
          return;
        }
      }
    });
    var startKitObserver = function () {
      kitObserver.observe(document.body, { childList: true, subtree: true });
      scheduleKitScan();
    };
    if (document.body) startKitObserver();
    else document.addEventListener('DOMContentLoaded', startKitObserver);
  } else if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleKitScan);
  } else {
    scheduleKitScan();
  }

  /* Checkout (carrello a scomparsa form#mini-cart e pagina carrello form[data-smart-cart-form]) */
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.getAttribute) return;
    if (form.id !== 'mini-cart' && !form.hasAttribute('data-smart-cart-form')) return;
    if (form.getAttribute('data-sa-kit-checked') === 'true') return;
    if (!kitBusy && !document.querySelector(KIT_SELECTOR)) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    if (kitCheckoutPending) return;
    kitCheckoutPending = true;

    var button = form.querySelector('[name="checkout"]');
    if (button) {
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
    }

    var run = kitBusy ? kitBusy.then(function () { return swapKitLines(true); }) : swapKitLines(true);
    run.then(function (result) {
      kitCheckoutPending = false;
      if (result === false) {
        /* Riga kit ancora nel carrello: niente checkout. Messaggio gia' mostrato se l'aggiunta e' fallita. */
        if (button) {
          button.disabled = false;
          button.removeAttribute('aria-busy');
        }
        syncKitError();
        if (!document.querySelector('[data-sa-kit-error]')) refreshAfterKit();
        return;
      }
      /* Scambio fatto (o niente da scambiare): invio nativo verso il checkout.
         form.submit() non genera un nuovo evento submit; il campo checkout sostituisce il pulsante. */
      var marker = document.createElement('input');
      marker.type = 'hidden';
      marker.name = 'checkout';
      marker.value = '1';
      form.appendChild(marker);
      form.setAttribute('data-sa-kit-checked', 'true');
      HTMLFormElement.prototype.submit.call(form);
    });
  }, true);
})();
